import {createSlice, createSelector} from '@reduxjs/toolkit'

const initialState = {
  snackBars: [],
}

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    enqueueSnackBar(state, action) {
      const messages = action.payload || []

      let stackedMessages = []

      if ((action.payload || []).length) {
        stackedMessages = messages.map(snack => snack)
      } else {
        stackedMessages = [
          {
            ...action.payload,
            key: action.payload?.key,
          },
        ]
      }

      state.snackBars = [...state.snackBars, ...stackedMessages]
    },
    closeSnackBar(state, action) {
      state.snackBars = (state.snackBars || []).map(snackBar =>
        action.payload?.dismissAll || snackBar.key === action.payload?.key
          ? {...snackBar, dismissed: true}
          : {...snackBar},
      )
    },
    removeSnackBar(state, action) {
      state.snackBars = (state.snackBars || []).filter(
        snackBar => snackBar.key !== action.payload?.key,
      )
    },
  },
})

export const {enqueueSnackBar, closeSnackBar, removeSnackBar} = notificationsSlice.actions

// selectors
const snackBarsState = store => store.notifications.snackBars

export const snackBarSelector = createSelector(snackBarsState, store => store)

export default notificationsSlice.reducer
